import React from 'react'
import PropTypes from 'prop-types'

import Error from 'components/Error'

import FilterPageLoader from './[section]'
import HeadlessLayout from 'layout/HeadlessLayout'

import FilterPage from 'apps/FilterPage'

const SearchPageLoader = (props) => {
  const { statusCode } = props

  const searchPageProps = {
    ...props,
    hasSeoHeader: false,
    hideFilters: true,
    isSearchPage: true,
  }

  if (statusCode) {
    return <Error {...searchPageProps} />
  }

  return <FilterPage {...searchPageProps} />
}

SearchPageLoader.getInitialProps = FilterPageLoader.getInitialProps
SearchPageLoader.Layout = HeadlessLayout
SearchPageLoader.propTypes = {
  statusCode: PropTypes.number,
}

export default SearchPageLoader
